var map = {
	"./ss1.jpg": 2837,
	"./ss10.jpg": 8889,
	"./ss2.jpg": 5610,
	"./ss3.jpg": 7543,
	"./ss4.jpg": 7308,
	"./ss5.jpg": 5097,
	"./ss6.jpg": 9950,
	"./ss7.jpg": 107,
	"./ss8.jpg": 4800,
	"./ss9.jpg": 6541
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5701;